module.exports = __webpack_public_path__ + "1c3a465d2b016fdb33ed4584d7c767c9.png";